/***
*
*   WEBAPP CLIENT HELPER
*   The single sanctioned way Mission Control's frontend builds a URL
*   into app.lawcyborg.com and records that a call happened (CORE-3862).
*   Any other client/src file template-stringing authContext.remote_server
*   directly is a regression — see __tests__/webapp.guard.test.js.
*
**********/

import Axios from 'axios';

// Builds a full URL to call the webapp directly from the browser.
export function buildWebappUrl(remoteServer, path){

  return `${remoteServer}${path}`;

}

// Records one support_audit_log row for a direct webapp call, via MC's
// own POST /api/audit. Fire-and-forget: an audit failure must never fail
// or block the support action it's describing (mirrors middleware/audit.js).
export function recordWebappAudit(entry){

  Axios.post('/api/audit', entry).catch(() => {});

}
